// 全局计数器：跟踪当前打开的菜单数量
let openMenuCount = 0;

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.closingTimeout = null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    // ⭐ 这里改了：hover 用专门的 onHoverEnter，离开还是用 closeWithClosingClass
    this.openHandler = this.onHoverEnter.bind(this);
    this.closeWithClosingClassHandler = this.closeWithClosingClass.bind(this);
    
    if (!this.dataset.ignoreHover) {
      this.isAbleToUseMouse = matchMedia('(hover: hover)').matches;

      // ⭐ 用箭头函数 + 不再 bind(this)，避免重复绑定
      this.debouncedOnChange = debounce(() => {
        this.isAbleToUseMouse = matchMedia('(hover: hover)').matches;
        this.initHoverDetails();
      }, 300);
  
      window.addEventListener('resize', this.debouncedOnChange);
  
      this.initHoverDetails();
    }
    
    this.initClickSummary();
  }

  initHoverDetails () {
    if (this.isAbleToUseMouse) {
      Shopify.addListener(this.mainDetailsToggle, 'mouseenter', this.openHandler);
      Shopify.addListener(this.mainDetailsToggle, 'mouseleave', this.closeWithClosingClassHandler);
    } else {
      this.mainDetailsToggle.removeEventListener('mouseenter', this.openHandler);
      this.mainDetailsToggle.removeEventListener('mouseleave', this.closeWithClosingClassHandler);
    }
  }

  initClickSummary() {
    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
      e.preventDefault();
      if (this.mainDetailsToggle.hasAttribute('open')) {
        this.closeWithClosingClass();
      } else {
        this.open();
      }
    });
  }

  // ⭐ 新增：鼠标移入时先取消即将关闭的定时器 + 去掉 closing class，再打开
  onHoverEnter() {
    if (this.closingTimeout) {
      clearTimeout(this.closingTimeout);
      this.closingTimeout = null;
    }
    this.mainDetailsToggle.classList.remove('closing');
    
    // 立即关闭当前菜单（不带延迟），然后再打开新菜单
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    }
    this.open();
  }

  closeWithClosingClass() {
    if (this.classList.contains('ignore-close')) return;

    this.mainDetailsToggle.classList.add('closing');

    if (this.closingTimeout) {
      clearTimeout(this.closingTimeout);
    }

    // ⭐ 这里的 300ms 对应 CSS 动画时长，可以按感觉改成 220~260 也行
    this.closingTimeout = setTimeout(() => {
      this.close();
      this.mainDetailsToggle.classList.remove('closing');
    }, 300);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.closeWithClosingClass();
    this.mainDetailsToggle.querySelector('summary').focus();
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.closeWithClosingClass();
    });
  }

  playAnimation() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', true);
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    this.playAnimation();

    // 只有在 header 内的菜单才需要同步 header 类名
    const isInHeader = this.closest('.header-wrapper, .header');
    if (isInHeader) {
      openMenuCount++;
      const header = document.querySelector('.header-wrapper .header');
      if (header) header.classList.add('header-active');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    // 只有在 header 内的菜单才需要处理 header 类名
    const isInHeader = this.closest('.header-wrapper, .header');
    if (isInHeader) {
      setTimeout(() => {
        openMenuCount--;

        // 只有当所有菜单都关闭时才移除类名
        if (openMenuCount <= 0) {
          openMenuCount = 0;
          const header = document.querySelector('.header-wrapper .header');
          if (header) header.classList.remove('header-active');
        }
      }, 50);
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

let hoverSupport = matchMedia('(hover: hover)').matches;
window.addEventListener('resize', () => {
  hoverSupport = matchMedia('(hover: hover)').matches;
});

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header');
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.querySelectorAll(':scope > details > .header__menu-item--link')
      .forEach(element => element.addEventListener('click', this.onClickSummary));
  }

  onClickSummary(event) {
    if (hoverSupport) {
      event.preventDefault();
      window.location = event.currentTarget.dataset.href;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);